import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import "../Dashboard/Dashboard.css";
import { Link } from "react-router-dom";
import TeacherTable from "../Dashboard/TeacherTable";
import StudentTable from "../Dashboard/StudentTable";
import TopImage from "../../common/TopImage";
import { Images } from "../../../../config/images";


export const OrgSchoolInvoices = () => {
  const [activeTab, setActiveTab] = useState(
    /** @type {"teachers" | "students"} */ ("teachers"),
  );
  const [selectedPercentage, setSelectedPercentage] = useState("30%");

  const percentageOptions = [
    "30%",
    "40%",
    "45%",
    "50%",
    "55%",
    "60%",
    "65%",
    "70%",
    "80%",
    "85%",
    "90%",
    "95%",
  ];

  return (
    <>
      <div className="container-fluid p-0">
        <div className="p-0" id="">
          <section>
            <div className="container-fluid">
              <TopImage imageSrc={Images.TopImage} text="INVOICES" />

              {/* Stats Cards */}
              <div className="row g-3 mb-4 mt-4">

                <div className="col-lg-4 col-md-4">
                  <div className="stat-card stat-card-green h-100">
                    <div className="stat-card-icon">
                      <i className="bi bi-person"></i>
                    </div>
                    <div className="stat-card-content">
                      <p className="stat-card-label">Total Licenses Purchased</p>
                      <h3 className="stat-card-value">100</h3>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4">
                  <div className="stat-card stat-card-orange h-100">
                    <div className="stat-card-icon">
                      <i className="bi bi-flag-fill"></i>
                    </div>
                    <div className="stat-card-content">
                      <p className="stat-card-label">Licenses Assigned</p>
                      <h3 className="stat-card-value">30</h3>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4">
                  <div className="stat-card stat-card-purple">
                    <div className="stat-card-icon">
                      <i className="bi bi-mortarboard"></i>
                    </div>
                    <div className="stat-card-content h-100">
                      <p className="stat-card-label">Licenses Available</p>
                      <h3 className="stat-card-value">70</h3>
                    </div>
                  </div>
                </div>

              </div>

              
            
            </div>
          </section>
          <div>
            <div className="tabs-container">
             
              <TeacherTable />
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};
